export default __webpack_public_path__ + "static/media/background-auth-layout.47cfd635.jpg";